export enum ApiUrlsEnum {
  /** POST with ILoginDto */
  auth = '/api/Accounts/token',

  /** GET with IFilterQuery query params */
  membersList = '/api/Members',

  /** GET with {member ID} */
  memberDetail = '/api/Members/',

  /** DELETE with {member ID} */
  deleteMember = '/api/Members/',

  /** GET */
  promoSets = '/api/Promo/Sets',
  /** GET/POST/PUT/DELETE */
  promoSet = '/api/Promo/Set',
  /** GET set goods {id: set id, filter: filter value } */
  promoSetGoods = '/api/Promo/Goods',

  /** GET/POST/PUT/DELETE */
  promoGood = '/api/Promo/Good',

  /** POST */
  uploadSets = '/api/Promo/UploadSets',

  /** GET without params */
  downloadSets = '/api/Promo/DownloadSets',

  /** GET with filter */
  help = '/api/Help',

  /** POST message to bot */
  helpSendMessage = '/api/Help',

  /** GET */
  unreadCount = '/api/Help/UnreadCount',

  /** GET */
  coupones = '/api/Coupons',

  /** POST */
  couponesUpload = '/api/Coupons/UploadCoupons',

  /** GET */
  couponesDownload = '/api/Coupons/DownloadCoupons',

  /** GET */
  eventList = '/api/Events',

  /** GET */
  accountsAutocomplete = '/api/Accounts/AutoComplete',

  incidents = '/api/Incidents',
}
